<template>
  <form name="company" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-info-circle"></i> Informações gerais</h5>
    </div>
    <div class="row mb-4">
      <div class="col-md-2" v-if="data.id">
        <label>ID Carteira</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder
            v-model="data.id"
            readonly="readonly"
          />
        </div>
      </div>
      <div :class="{ 'col-md-5': data.id, 'col-md-7': !data.id }">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name">
            Nome fantasia
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              id="name"
              type="text"
              ref="name"
              class="form-control m-input"
              placeholder
              v-model="data.name"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.co_name }">
          <label for="co_name">
            Razão Social
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="co_name"
              id="co_name"
              placeholder
              v-model="data.co_name"
              required
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-2">
        <label>
          Documento
          <span></span>
        </label>
        <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
          <label
            class="btn btn-secondary"
            @click="
              doctype = 0;
              data.cnpj = '';
            "
            :class="{ active: doctype == 0 }"
          >
            <input type="radio" name="doctype" v-model="doctype" v-show="doctype == 0" value="0" />
            CNPJ
          </label>
          <label
            class="btn btn-secondary"
            @click="
              doctype = 1;
              data.international = false;
            "
            :class="{ active: doctype == 1 }"
          >
            <input type="radio" name="doctype" v-model="doctype" v-show="doctype == 1" value="1" />
            CPF
          </label>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.cnpj }">
          <label for="cnpj">
            {{ doctype == 0 ? 'CNPJ' : 'CPF' }}
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              id="cnpj"
              placeholder
              v-model="data.cnpj"
              v-mask="
                doctype == 0 ? (data.international ? '' : 'NN.NNN.NNN/NNNN-##') : '###.###.###-##'
              "
              @keyup="data.international ? '' : validateDocument(data.cnpj)"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-1">
        <label>Internacional</label>
        <div class="input-group">
          <span class="m-switch m-switch--icon" title="Cliente Internacional">
            <label>
              <input
                type="checkbox"
                @change="!data.international"
                name="international"
                v-model="data.international"
                :disabled="doctype == 1"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-4">
        <label for="municipal_reg">Insc. Municipal</label>
        <div class="input-group">
          <input
            id="municipal_reg"
            type="text"
            class="form-control"
            placeholder
            v-model="data.municipal_reg"
          />
        </div>
      </div>

      <div class="col-md-4">
        <label for="state_reg">Insc. Estadual</label>
        <div class="input-group">
          <input
            id="state_reg"
            type="text"
            class="form-control"
            placeholder
            v-model="data.state_reg"
          />
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-4">
        <div class="form-group">
          <label for="domain">Domínio</label>
          <div class="input-group">
            <input
              id="domain"
              type="text"
              class="form-control m-input"
              placeholder
              v-model="data.domain"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label for="contaazul_id">ID do ContaAzul</label>
        <div class="input-group">
          <input
            id="contaazul_id"
            type="text"
            class="form-control"
            placeholder
            v-model="data.contaazul_id"
          />
        </div>
      </div>
      <div class="col-md-1">
        <label>POC</label>
        <div class="input-group">
          <span class="m-switch m-switch--icon">
            <label>
              <input type="checkbox" @change="!data.poc" name="poc" v-model="data.poc" />
              <span></span>
              <small class="modified_field" v-if="data.audit.field.includes('poc')"
                >Modificado por: {{ data.audit.user }} às
                {{ data.audit.created_at | datetime }}</small
              >
            </label>
          </span>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-md-4">
        <label for="start">Início</label>
        <div class="input-group">
          <input
            type="date"
            name="start"
            max="9999-12-31"
            id="start"
            class="form-control m-input"
            v-model="data.start"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="finish">Término</label>
          <div
            class="input-group"
            :class="{ 'has-danger': data.finish && data.start > data.finish }"
          >
            <input
              type="date"
              name="finish"
              max="9999-12-31"
              id="finish"
              class="form-control m-input"
              v-model="data.finish"
            />
          </div>
          <span class="m-form__help m--font-danger" v-if="data.finish && data.start > data.finish"
            >Data de término não pode ser anterior a data de início!</span
          >
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.name.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.name"
          >
            O campo
            <strong>Nome</strong> é obrigatório *
          </a>
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.co_name.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.co_name"
          >
            O campo
            <strong>Razão Social</strong> é obrigatório *
          </a>
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.cnpj.focus()"
            target="_self"
            class="m--font-danger"
            v-if="data.cnpj && !validateCnpj(data.cnpj) && doctype == 0 && !data.international && !isAlphanumericCnpj(data.cnpj)"
            ><strong>CNPJ</strong> inválido *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.cnpj.focus()"
            target="_self"
            class="m--font-danger"
            v-if="data.cnpj && !validateCpf(data.cnpj) && doctype == 1"
            ><strong>CPF</strong> inválido *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.cnpj.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.cnpj"
          >
            O campo
            <strong>{{ doctype == 0 ? 'CNPJ' : 'CPF' }}</strong> é obrigatório *
          </a>
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import { validationMixin } from '@/mixins/validationMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin, validationMixin],
  name: 'CompanySaveForm',
  data() {
    return {
      doctype: 0,
      data: {
        contract_type: 0,
        audit: {
          field: [],
          user: false,
        },
        international: false,
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    setDocType() {
      if (this.data.cnpj != '' && this.data.cnpj.length <= 11) {
        this.doctype = 1;
      }
      this.setInternational();
    },
    setInternational() {
      if (this.doctype == 0) {
        const cleanCnpj = this.data.cnpj.replace(/[^0-9A-Za-z]/g, '');
        const isBrazilianFormat = /^[0-9A-Za-z]{1,14}$/.test(cleanCnpj);
        this.data.international = !isBrazilianFormat && this.data.cnpj.length > 0;
      }
    },
    validateDocument(document) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.doctype == 0) {
          if (this.validateCnpj(document)) {
            this.alert.message = '';
          } else if (document.length === 18 && !this.isAlphanumericCnpj(document)) {
            this.logMessageFormFailed({
              data: {
                message: 'CNPJ Inválido',
              },
            });
          }
        } else if (this.doctype == 1) {
          if (this.validateCpf(document)) {
            this.alert.message = '';
          } else if (document.length === 14) {
            this.logMessageFormFailed({
              data: {
                message: 'CPF Inválido',
              },
            });
          }
        }
      }, 1000);
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;

      const url = `${baseApiUrl}/v1/company/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.data = data;
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/company/data/${this.companyId}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.setDocType(this.data.cnpj);
      });
    },
    callData() {
      this.getDatas();
    },
  },
  computed: {
    companyId() {
      return this.$store.state.showCompanySave;
    },
    formIsValid() {
      if (
        (this.data.name &&
          this.data.co_name &&
          this.doctype == 0 && !this.data.international && (this.validateCnpj(this.data.cnpj) || this.isAlphanumericCnpj(this.data.cnpj))) ||
        (this.doctype == 0 && this.data.international) ||
        (this.doctype == 1 && this.validateCpf(this.data.cnpj))
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.companyId && this.companyId !== 'add') {
      this.callData();
    }
  },
};
</script>

<style></style>
